import React from 'react';

/**
 * Phase 21 — Bucket pill (Web).
 *
 * Small pill rendered next to a category name showing its QuickBooks-aligned
 * account-type bucket. Colors come from the backend `GET /api/categories/buckets`
 * catalog so we never hardcode labels/colors in two places.
 *
 * Props:
 *   bucket   — string bucket code ("asset" | "liability" | …) or null
 *   catalog  — array from `getBuckets()` (contains {code,label,color,order})
 *   size     — 'sm' (default) | 'xs'
 */
export default function BucketPill({ bucket, catalog, size = 'sm' }) {
  if (!bucket || !catalog?.length) return null;
  const meta = catalog.find((b) => b.code === bucket);
  if (!meta) return null;
  const isXs = size === 'xs';
  return (
    <span
      data-testid={`bucket-pill-${meta.code}`}
      className={`inline-flex items-center rounded-full font-semibold tracking-wide ${isXs ? 'px-1.5 py-0 text-[9px]' : 'px-2 py-0.5 text-[10px]'}`}
      style={{
        backgroundColor: `${meta.color}22`,
        color: meta.color,
        border: `1px solid ${meta.color}44`,
        whiteSpace: 'nowrap',
      }}
    >
      {meta.label}
    </span>
  );
}
